import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { EmpdContext } from '../../Context';

interface Option {
  label: string;
  value: string;
}

interface Props {
    sx?: any,
    multiple?: boolean,
    value: any,
    ontology: string,
    label: string,
    onChange: (event: React.SyntheticEvent, value: any) => void,
}

const useMyContext = () => {
    const context = React.useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

export default function AsyncSelect({ sx, multiple, ontology, value, label, onChange }: Props) {

  const { fetchBioOptions } = useMyContext();

  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly Option[]>([{label:'', value: ''}]);
  const [loading, setLoading] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
    (async () => {
      setLoading(true);
      const opt = await fetchBioOptions(ontology, value.value)
      setOptions(opt);
      setLoading(false);

    })();
  };

  const handleClose = () => {
    setOpen(false);
//    setOptions([]);
  };

  return (
    <Autocomplete
      sx={sx}
      multiple={multiple}
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      onChange={onChange}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => {
        if( option.hasOwnProperty('label') ) {
            return option.label
        } else {
            return ''
        }
      }}
      options={options}
      loading={loading}
      value={value}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            },
          }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                (async () => { 
                    setLoading(true)
                    const opt = await fetchBioOptions(ontology, event.target.value)
                    setOptions(opt)
                    setLoading(false)
                })()
          }}
        />
      )}
    />
  );
}
